<template>
<div class="handle">
  <div class="handle-body">
    <div style="margin-top: 20px"></div>
    <el-descriptions :column="1" size="mini" :label-style="{width: '80px'}" border>
      <el-descriptions-item v-if="handle_config.handle_value&&handle_config.handle_value.length" label="操作">
        <el-radio @change="actionChange" :disabled="is_disabled" v-for="(item,index) in handle_config.handle_value" :key="index" size="mini" v-model="form.select_action" :label="item">{{ item }}</el-radio>
      </el-descriptions-item>
      <el-descriptions-item v-if="handle_config.additional_value&&handle_config.additional_value.length" label="附加操作">
        <el-radio v-if="showAction" :disabled="is_disabled" v-for="(item,index) in handle_config.additional_value" :key="index" size="mini" @input="additionalInput" v-model="form.additional_value" :label="item">{{ item }}</el-radio>
      </el-descriptions-item>

      <el-descriptions-item v-if="form.additional_value==='内部会签'" label="会签人">
        <BpmnSelectUser :disabled="is_disabled" v-model="form.additional_user_list" />
      </el-descriptions-item>
      <el-descriptions-item v-if="form.additional_value==='委托处理'" label="委托人">
        <BpmnSelectUser :disabled="is_disabled" :user_len="1" v-model="form.additional_user_list" />
      </el-descriptions-item>
      <el-descriptions-item v-if="form.additional_value==='内部会签'||form.additional_value==='委托处理'" label="处理后">
        <el-radio :disabled="is_disabled" v-for="(item,index) in [{name:'回到本人'},{name:'不需要回'}]" :key="index" size="mini" v-model="form.after_processing" :label="item.name">{{ item.name }}</el-radio>
      </el-descriptions-item>
      <!-- 流程图控制 -->
<!--      <el-descriptions-item v-if="handle_config.urgency" label="紧急程度">-->
<!--        <el-select :disabled="is_disabled" size="mini" v-model="form.urgency_level" placeholder="请选择">-->
<!--          <el-option-->
<!--            v-for="(item,index) in ['一般','紧急','加急']"-->
<!--            :key="index"-->
<!--            :label="item"-->
<!--            :value="item">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </el-descriptions-item>-->
      <!-- 只有发起才有紧急程度 -->
      <el-descriptions-item v-if=" step_id == '' " label="紧急程度">
        <el-select :disabled="is_disabled" size="mini" v-model="form.urgency_level" placeholder="请选择">
          <el-option
            v-for="(item,index) in ['一般','紧急','加急']"
            :key="index"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-descriptions-item>

      <el-descriptions-item v-if="handle_config.remind_value&&handle_config.remind_value.length" label="提醒方式">
        <el-radio :disabled="is_disabled" v-for="(item,index) in handle_config.remind_value" :key="index" size="mini" v-model="form.remind_value" :label="item">{{ item }}</el-radio>
      </el-descriptions-item>
      <el-descriptions-item v-if="handle_config.suggestion" label="意见">
        <div style="display: flex; margin-bottom: 5px">
          <el-select size="mini" v-model="comments_value" @change="onComments" placeholder="快捷短语">
            <el-option
              v-for="(item,index) in msgTableData"
              :key="index"
              :label="item.content"
              :value="item.content">
            </el-option>
          </el-select>
          <el-button type="primary" :disabled="is_disabled" size="mini" :loading=buttonLoading v-if="step_id"
                     v-on:click="quickReplyBox">管理
          </el-button>
        </div>
        <el-input
          :disabled="is_disabled"
          type="textarea"
          placeholder="请填写意见……"
          v-model="form.comments"
          maxlength="10000"
          :autosize="{ minRows: 4, maxRows: 10000 }"
          :rows="4"
        >
        </el-input>
      </el-descriptions-item>
    </el-descriptions>

    <div v-if="(handle_config.is_submit||handle_config.is_staging) && is_look === false" class="handle-item">
      <el-button :disabled="is_disabled" size="mini" :loading = buttonLoading  v-if="handle_config.is_submit&&isEdit" v-on:click="submit2">提交</el-button>
<!--      <el-button :disabled="is_disabled" size="mini" :loading = buttonLoading  v-if="handle_config.is_submit" v-on:click="updateFlowUser">修改审批人</el-button>-->
      <el-button :disabled="is_disabled" size="mini" :loading = buttonLoading v-if="handle_config.is_staging&&isEdit" v-on:click="submitDraft">暂存</el-button>
    </div>


    <div v-if=" (typeof handle_config.enclosure == 'undefined' && is_look) || handle_config.enclosure" class="handle-item">
      <el-descriptions direction="vertical" class="file-list" :column="1" border>
        <el-descriptions-item label="附件">
          <el-table
            size="mini"
            :data="tableData"
            border
            :cell-style="{padding:0}"
            style="width: 290px">
            <el-table-column
              label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" icon="el-icon-download" @click="taskView(scope.row,2)">下载</el-button>
                <el-button type="danger" v-if="scope.row.is_edit==1&&isEdit" :disabled="is_disabled" size="mini" icon="el-icon-delete" @click="deleteTaskFile(scope.row)">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="file_name"
              label="文件名"
              width="180">
              <template slot-scope="scope">
                <el-link type="primary" @click="taskView(scope.row,1)">{{scope.row.file_name}}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="上传人/时间" width="180">
              <template slot-scope="scope">
                {{scope.row.user_name}} / {{scope.row.create_time}}
              </template>
            </el-table-column>

          </el-table>
          <div class="handle-item-file-bottom" v-if="is_look === false&&isEdit">
            <el-button :disabled="is_disabled" size="mini" @click="uploadFlowFile">上传资料</el-button>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>

  </div>
  <ViewFile ref="ViewFile" />
  <NodeProcessSteps ref="NodeProcessSteps" />

  <el-dialog title="快捷回复列表" :visible.sync="quickReplyBoxVisible" width="500px">

    <el-table :data="msgTableData" border style="width: 100%" height="300">
      <el-table-column prop="content" label="内容">
        <template slot-scope="scope">
          <div class="history_user_body_item" @click="selectMsg(scope.row)">
            {{ scope.row.content }}
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot="header" slot-scope="scope">
          <el-button @click="addMsgBox('')" type="primary" size="small">管理</el-button>
        </template>
        <template slot-scope="scope">
          <el-button @click="selectMsg(scope.row)" type="text" color="#409EFF" size="small">选择</el-button>
          <el-button type="text" @click="addMsgBox(scope.row)" size="small">编辑</el-button>
          <el-button type="text" @click="delMsg(scope.row)" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      width="30%"
      title="新增/编辑"
      :visible.sync="quickReplyBoxEditVisible"
      append-to-body>
      <div>
        <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="msgText"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quickReplyBoxEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveMsg()">保存</el-button>
      </div>
    </el-dialog>
    <div slot="footer" class="dialog-footer">
      <el-button @click="quickReplyBoxVisible = false">取 消</el-button>
      <!--      <el-button type="primary" @click="quickReplyBoxEditVisible = true">打开内层 Dialog</el-button>-->
    </div>
  </el-dialog>

</div>
</template>

<script>
import Http from "../common/Http";
import BpmnSelectUser from "../bpmn/PropertySetting/components/BpmnSelectUser";
import FlowSheet from "../bpmn/lib/FlowSheet";
import ViewFile from "../../Common/ViewFile";
import NodeProcessSteps from "./NodeProcessSteps";

export default {
  name: "FlowHandleDom",
  components: {ViewFile, BpmnSelectUser, NodeProcessSteps},
  inject:['__FLOW_PAGE__'],
  props:{
    step_id:{
      type:Number|String,
      default() {
        return "";
      }
    },
    sheet_id:{
      type:Number|String,
      default() {
        return "";
      }
    },
    task_id:{
      type:Number|String,
      default() {
        return "";
      }
    },
    status:{
      type:Number|String,
      default() {
        return "";
      }
    },
    node_id:{
      type:String,
      default() {
        return "";
      }
    },
    masterData:{
      type:Object,
      default() {
        return {};
      }
    },
    isEdit:{
      type:Boolean,
      default() {
        return false;
      }
    },
  },
  data(){
    return{
      host_url:Http.getBaseURL(),
      handle_config:{},
      form:{
        select_action:"",//操作
        additional_value:"",//附加操作
        additional_user_list:[],//会签人/委托人
        after_processing:"",//处理后
        urgency_level:"一般",//紧急程度
        remind_value:"及时消息",//提醒方式
        comments:"同意原文意见",//意见
      },
      tableData:[],
      is_disabled:true,
      temp_task_id:(new Date()).getTime().toString().slice(0,10)+""+_.random(100,999),
      comments_value:"",
      comments_list:[{id:1,value:"同意"},{id:2,value:"不同意"},{id:3,value:"有需要修改一下"}],
      buttonLoading : false,
      showAction: true,
      is_look:false,
      quickReplyBoxVisible:false,
      quickReplyBoxEditVisible:false,
      msgTableData:[],
      msgText:"",
      msgId:0,
    }
  },
  mounted() {
    this.getNodeStep();
    this.getNodeData();
    this.getTaskFile();
    this.tableData=[];
    this.msgTableData=[];
    this.getQuickReply();

    // 检查url是否带有文件路径
    let filePath = this.$route.query.file_local
    let fileTitle = this.$route.query.file_title
    let baseUrl = this.$route.query.base_url
    if (typeof this.$route.query.is_look != "undefined" ) {
      this.is_look = this.$route.query.is_look
    }
    if (filePath && this.temp_task_id) {
      // 把文件插入flow_task_file表
      Http.post("flow/FlowTaskFile/save",{
        task_id:this.temp_task_id,
        file_name:fileTitle,
        file_url:filePath,
        base_url:baseUrl,
        is_data : 1
      },ret=>{
        if(ret.code){
          this.getTaskFile()
        }else {
          this.$message.error('上传失败');
        }
      })
    }
  },
  methods:{
  // 判断当前节点是否有权限审批
    getNodeStep(){
      const that = this;
      if(that.step_id){
        Http.get("flow/FlowProcessSteps/get",{
          id:that.step_id
        },res=>{
          if(res.code) {
            that.is_disabled = !!res.data.is_handle
            if (that.is_disabled == true) {
              // 判断是否退回重填，退回重填的可以再次编辑
              that.checkIsReturn();
            }
          }
        })
      }else {
        that.is_disabled=false;
      }
    },
    getNodeData(){
      const that = this;
      // // 判断是否有权限可以操作审批单
      // if (this.step_id) {
      //   Http.get("flow/FlowHandle/checkHandle",{step_id:that.step_id},isCheck=>{
      //     (this.sheet_id&&this.node_id)&&Http.get("flow/FlowSheet/getProperties",{id:that.sheet_id,name:"id",value:that.node_id},ret=>{
      //       if(ret.code===1){
      //         that.handle_config=ret.data;
      //         that.handle_config.is_submit = isCheck;
      //         that.is_disabled= !isCheck;
      //         if(that.handle_config.handle_value&&that.handle_config.handle_value.length){
      //           if(that.handle_config.handle_value.includes('同意')){
      //             that.form.select_action='同意';
      //           }
      //         }
      //       }
      //     })
      //   })
      // } else {
      //   (this.sheet_id&&this.node_id)&&Http.get("flow/FlowSheet/getProperties",{id:that.sheet_id,name:"id",value:that.node_id},ret=>{
      //     if(ret.code===1){
      //       that.handle_config=ret.data;
      //       if(that.handle_config.handle_value&&that.handle_config.handle_value.length){
      //         if(that.handle_config.handle_value.includes('同意')){
      //           that.form.select_action='同意';
      //         }
      //       }
      //     }
      //   })
      // }
      (this.sheet_id&&this.node_id)&&Http.get("flow/FlowSheet/getProperties",{id:that.sheet_id,name:"id",value:that.node_id},ret=>{
        if(ret.code===1){
          that.handle_config=ret.data;
          if(that.handle_config.handle_value&&that.handle_config.handle_value.length){
            if(that.handle_config.handle_value.includes('同意')){
              that.form.select_action='同意';
            }
          }
        }
      })
    },
    submit2(){
      const that = this;
      // if (that.form.additional_value == '内部会签' || that.form.additional_value == '委托处理') {
      //   if (that.form.additional_user_list == '' || that.form.additional_user_list.length == 0) {
      //     that.$message.error('请添加加签或委托人！');
      //     return false
      //   }
      // }
      this.buttonLoading = true
      if(that.task_id && that.status != 10 && that.status != 11){
        // 审批流程
        that.submit();
        return false
      }

      let data={};
      //流程
      let flow_path=(that.$parent.$refs.vFormRef.getFlowPath()).map(ret=>ret.id);
      // 如果是撤回的审批单，需要传入task_id
      if (that.status == '10' || that.status == 11) {
        // 通过条件节点获取整个流程
        let formData = that.$parent.$refs.vFormRef.formDataModel
        let vFomrStore = that.$parent.$refs.vFormRef.getVformStore()
        let conditionArr = [];
        // 节点的字符串长度 36，里面包含4个 '-'
        for(let index in formData) {
          if (typeof formData[index] == 'string') {
            if (formData[index].split('-').length === 5 && formData[index].length === 36) {
              // 条件线
              conditionArr.push(formData[index])
            }
          }
        }

        let flowSheet = new FlowSheet(vFomrStore['graph_data']);
        let get_flow_path = flowSheet.chooseAllSequence(conditionArr)
        if (typeof get_flow_path == 'object') {
          flow_path = get_flow_path[0];
        }
        data.task_id = that.task_id
      }

      let node_val={}
      flow_path.map(ret=>{
        node_val[ret]=that.$parent.$refs.vFormRef.formDataModel[ret]
      })
      data.step_id=that.step_id;//步骤ID
      data.flow_line=flow_path.join(',');//线路
      data.sheet_id=this.sheet_id;//流程图ID
      data.process_name=this.masterData.flow_master.name;//流程名称
      data.node_val=JSON.stringify(node_val);//节点对象
      data.flow_form=JSON.parse(JSON.stringify(this.form))

       //表单
      data.form_data={}
      //过滤流程节点
      let form_keys=Object.keys(that.$parent.$refs.vFormRef.formDataModel)
      form_keys.map(ret=>{
        if(!flow_path.includes(ret)){
          data.form_data[ret]=that.$parent.$refs.vFormRef.formDataModel[ret]
          if (typeof that.$parent.$refs.vFormRef.getWidgetRef(ret).tableData != "undefined") {
            data.form_data[ret] = JSON.stringify(that.$parent.$refs.vFormRef.getWidgetRef(ret).tableData)
          }
          else
          {
            if (typeof that.$parent.$refs.vFormRef.getWidgetRef(ret).$data != "undefined"
               && typeof that.$parent.$refs.vFormRef.getWidgetRef(ret).$data.dataList != "undefined") {
              data.form_data[ret] = JSON.stringify(that.$parent.$refs.vFormRef.getWidgetRef(ret).$data.dataList)
            }
          }
        }
      })
      data.form_id = this.masterData.flow_master.form_id||15;
      data.vform_json = this.__FLOW_PAGE__.$refs.vFormRef.formJsonObj;

      // 验证提交的数据
      let checkRes = this.checkFormData(data.form_data)
      if (checkRes['res'] == false) {
        this.buttonLoading = false
        that.$message.error(checkRes.msg);
        return;
      }

      // vform的全局方法引入可使用
      let flowFunction = this.__FLOW_PAGE__.$refs.vFormRef.formConfig.functions
      eval(flowFunction)
      // 判断审批单数据
      if(typeof(checkSubFormData) == "function" && checkSubFormData) {
        let res = checkSubFormData(this.__FLOW_PAGE__.$refs.vFormRef)
        if (res.isCheck == false) {
          this.$message.error(res.msg);
          this.buttonLoading = false
          return false
        }
      }
      // 判断审批人是否已选择
      if(typeof(checkSubSelectFlowNode) == "function" && checkSubSelectFlowNode) {
        let res = checkSubSelectFlowNode(this.__FLOW_PAGE__.$refs.vFormRef)
        if (res.isCheck == false) {
          this.$message.error(res.msg);
          this.buttonLoading = false
          return false
        }
      }

      Http.post("flow/FlowHandle/create", data, ret => {
        this.buttonLoading = false
        if (ret.code === 1) {
          ((ret.data.user || {}).name) && that.$message.success("流程已经向" + (ret.data.user || {}).name + "发起")
          if (that.tableData.length !== 0) {
            that.updateFileTask(ret.data.task_id);
          }
          // that.$parent.$refs.vFormRef.getFlowConfig();
          // ERP.navigateBack()
          // that.$router.push({path: '/flow/FlowProcessSteps', query: {}});
          that.$emit("onFlowHandle",{code:1,msg:"提交成功"})
        } else {
          that.$message.error(ret.msg);
        }
      })
    },
    submit(){
      const that = this;
      let data=JSON.parse(JSON.stringify(this.form));
      data.step_id=that.step_id;
      data.additional_user_list=JSON.stringify(data.additional_user_list)

      // // 判断只有同意才能会签
      // if (that.form.select_action != '同意' && that.form.additional_value != '') {
      //   that.$message.error("'"+ that.form.select_action +"'操作不能" + that.form.additional_value);
      //   this.buttonLoading = false
      //   return;
      // }
      // 退回某步操作
      if (this.form.select_action === '退回某步') {
        // 打开流程节点列表
        let where = {
          task_id : that.task_id,
          parent_step_id : 0,
          is_handle : 1,
          node_type : 'user',
        }
        that.$refs.NodeProcessSteps.show(where, function(data){
          if (that.form.comments === "") {
            that.$message.error("请填写审批意见！");
            return false
          }
          let config = {
            return_id : data.id,
            task_id : data.task_id,
            step_id : that.step_id,
            comments : that.form.comments,
          }
          Http.post("flow/FlowProcessSteps/returnNodeProcessStep",config,ret=>{
            this.buttonLoading = false
            if(ret.code){
              // that.$router.push({path:'/flow/FlowProcessSteps',query:{}});
              that.$emit("onFlowHandle",{code:1,msg:"退回成功"})
            }else {
              that.$message.error(ret.msg||"提交数据出现异常");
            }
          })
        });
        this.buttonLoading = false
        return;
      }

      let new_form_data = that.getCanEditFormData()
      if (JSON.stringify(new_form_data) === '{}') {
        Http.post("flow/FlowHandle/handle",data,ret=>{
          this.buttonLoading = false
          if(ret.code){
            that.getNodeStep();
            //that.$parent.getFormData(that.task_id)
            (((ret.data||{}).user||{}).name)&&that.$message.success("流程已经向"+((ret.data||{}).user||{}).name+"发起");
            // ERP.navigateBack()
            // that.$router.push({path:'/flow/FlowProcessSteps',query:{}});
            that.$emit("onFlowHandle",{code:1,msg:"审批成功"})
          }else {
            that.$message.error(ret.msg||"提交数据出现异常");
          }
        })
      } else {
        Http.post("flow/FlowHandle/updateFormData",{
          task_id:that.task_id,
          form_data:JSON.stringify(new_form_data)
        },res=>{
          if(res.code){
            Http.post("flow/FlowHandle/handle",data,ret=>{
              this.buttonLoading = false
              if(ret.code){
                that.getNodeStep();
                //that.$parent.getFormData(that.task_id)
                (((ret.data||{}).user||{}).name)&&that.$message.success("流程已经向"+((ret.data||{}).user||{}).name+"发起");
                // ERP.navigateBack()
                // that.$router.push({path:'/flow/FlowProcessSteps',query:{}});
                that.$emit("onFlowHandle",{code:1,msg:"审批成功"})
              }else {
                that.$message.error(ret.msg||"提交数据出现异常");
              }
            })
          }else {
            this.buttonLoading = false
            that.$message.error(res.msg||"表单数据存储异常");
          }
        })
      }

    },
    updateFileTask(task_id){
      const that = this;
      let data={};
      data.ids=that.tableData.map(ret=>ret.id).join(',');
      data.task_id=task_id;
      Http.post("flow/FlowTaskFile/save",data,ret=>{
        if(ret.code){
          that.getTaskFile();
        }else {
          that.$message.error("文件提交异常");
        }
      })
    },
    additionalInput(value){
      const that = this;
      that.form.additional_user_list=[];
      if(value==='内部会签'){
        that.form.after_processing='回到本人';
      }else {
        that.form.after_processing='不需要回';
      }
    },
    getTaskFile(){
      const that = this;
      let where={
        task_id: this.task_id||this.temp_task_id,
      }
      Http.get("flow/FlowTaskFile/getList",{
        where:JSON.stringify(where),
        page: 1,
        page_size: 20
      },ret=>{
        if(ret.code){
          that.tableData=ret.data.list;
        }
      })
    },
    uploadFlowFile(){
      const that = this;
      Http.uploadFile(data=>{
        Http.post("flow/FlowTaskFile/save",{
          task_id:that.task_id||that.temp_task_id,
          file_name:data.name,
          file_url:data.path,
          storage_type:1,
        },ret=>{
          if(ret.code){
            that.getTaskFile()
          }else {
            that.$message.error('上传失败');
          }
        })
      })
    },
    taskView(item=null,type=1) {
      const that=this;
      console.log(item);
      if(item) {
        let file_url=""
        if (item.base_url) {
          file_url=item.base_url+ item.file_url
        }else {
          file_url=this.host_url+item.file_url
        }
        let login_name = localStorage.getItem('login')
        let token = localStorage.getItem('token')
        if(type===1){
          if(item.storage_type){
            that.$refs.ViewFile.show({
              width: '90vw',
              height:'80vh',
              title:item.file_name,
              src:item.file_url,
              bucket:'gdza',
              duration_time:86400*3,
              download(){
                // TODO 下载文件逻辑
                // window.open(`${that.host_url}/flow/FlowTaskFile/download?id=${item.id}&login_name=${login_name}&token=${token}`)
                __OSS__.setBucket('gdza').setKey(item.file_url).download()
              }
            })
            // downloadObj
            // Http.get("flow/FlowTaskFile/downloadObj", {id:item.id},res => {
            //   if(res.code) {
            //     that.$refs.ViewFile.show({
            //       width: '90vw',
            //       height:'80vh',
            //       title:item.file_name,
            //       src:res.data,
            //       download(){
            //         // TODO 下载文件逻辑
            //         window.open(`${that.host_url}/flow/FlowTaskFile/download?id=${item.id}&login_name=${login_name}&token=${token}`)
            //       }
            //     })
            //   }
            // })

          }else {
            that.$refs.ViewFile.show({
              width: '90vw',
              height:'80vh',
              title:item.file_name,
              src:file_url,
              download(){
                // TODO 下载文件逻辑
                window.open(`${that.host_url}/flow/FlowTaskFile/download?id=${item.id}&login_name=${login_name}&token=${token}`)
              }
            })
          }
        }else {
          if(item.storage_type){
            __OSS__.setBucket('gdza').setKey(item.file_url).download()
          }else {
            window.open(`${that.host_url}/flow/FlowTaskFile/download?id=${item.id}&login_name=${login_name}&token=${token}`)
          }
        }
      }
    },
    deleteTaskFile(item){
      const that = this;
      Http.post("flow/FlowTaskFile/delete", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getTaskFile()
        }
      })
    },
    submitDraft() {
      let that = this
      let formData = this.$parent.$refs.vFormRef.formDataModel
      Http.post("flow/FlowForm/createDraft",
        {master_id: that.masterData.flow_master.id, vform_data: formData,},
        res => {
          that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
          if (res.code) {
            that.getTaskFile()
          }
      })
    },
    // 获取审批单数据
    getFormData(){
      const that=this;
      let flow_path=(that.$parent.$refs.vFormRef.getFlowPath()).map(ret=>ret.id);
      //表单
      let form_data={}
      let edit_node = false
      if (typeof that.$parent.$refs.vFormRef.formDataModel['is_edit_node'] != "undefined" && that.$parent.$refs.vFormRef.formDataModel['is_edit_node'] == 1) {
        edit_node = true
      }
      //过滤流程节点
      let form_keys=Object.keys(that.$parent.$refs.vFormRef.formDataModel)
      form_keys.map(ret=>{
        // 过滤节点
        if (edit_node == true) {
          form_data[ret]=that.$parent.$refs.vFormRef.formDataModel[ret]
        } else {
          if(!flow_path.includes(ret)){
            form_data[ret]=that.$parent.$refs.vFormRef.formDataModel[ret]
          }
        }
      })
      return form_data;
    },
    // 获取可以修改的数据
    getCanEditFormData() {
      const that=this;
      let update_form_data = {};
      let vFomrStore = that.$parent.$refs.vFormRef.getVformStore()
      let fs=new FlowSheet(vFomrStore['graph_data'])
      let node=fs.getProperties("id",(that.node_id));
      let FormData = that.getFormData();

      if(node&&node.form_fields){
        let field_keys=Object.keys(node.form_fields)
        field_keys.map(ret=>{
          if(node.form_fields[ret]!==undefined){
            if (node.form_fields[ret].write) {
              update_form_data[ret] = FormData[ret]
            }
          }
        })
      }
      return update_form_data;
    },
    actionChange() {
      let value = this.form.select_action
      if (value == '同意') {
        this.showAction = true
        if (this.form.comments == '拒绝原文意见' || this.form.comments == '重填审批单' || this.form.comments == '同意原文意见' || this.form.comments == '内部会签' || this.form.comments == '委托处理' || this.form.comments == '退回某步' || this.form.comments == '') {
          this.form.comments = '同意原文意见'
        }
      }
      if (value == '拒绝') {
        this.showAction = false
        this.form.additional_value = ""
        this.form.additional_user_list = []
        if (this.form.comments == '拒绝原文意见' || this.form.comments == '重填审批单' || this.form.comments == '同意原文意见' || this.form.comments == '内部会签' || this.form.comments == '委托处理' || this.form.comments == '退回某步' || this.form.comments == '') {
          this.form.comments = '拒绝原文意见'
        }
      }
      if (value == '重填') {
        this.showAction = false
        this.form.additional_value = ""
        this.form.additional_user_list = []
        if (this.form.comments == '拒绝原文意见' || this.form.comments == '重填审批单' || this.form.comments == '同意原文意见' || this.form.comments == '内部会签' || this.form.comments == '委托处理' || this.form.comments == '退回某步' || this.form.comments == '') {
          this.form.comments = '重填审批单'
        }
      }
      if (value == '退回某步') {
        this.showAction = false
        this.form.additional_value = ""
        this.form.additional_user_list = []
        if (this.form.comments == '拒绝原文意见' || this.form.comments == '重填审批单' || this.form.comments == '同意原文意见' || this.form.comments == '内部会签' || this.form.comments == '委托处理' || this.form.comments == '退回某步' || this.form.comments == '') {
          this.form.comments = ''
        }
      }
    },
    onComments(val){
      this.form.comments=val;
    },
    updateFlowUser() {
      const that = this;
      // this.buttonLoading = true
      let data = {};
      //流程
      let flow_path = (that.$parent.$refs.vFormRef.getFlowPath()).map(ret => ret.id);
      // 通过条件节点获取整个流程
      let formData = that.$parent.$refs.vFormRef.formDataModel
      let vFomrStore = that.$parent.$refs.vFormRef.getVformStore()
      let conditionArr = [];
      // 节点的字符串长度 36，里面包含4个 '-'
      for (let index in formData) {
        if (typeof formData[index] == 'string') {
          if (formData[index].split('-').length === 5 && formData[index].length === 36) {
            // 条件线
            conditionArr.push(formData[index])
          }
        }
      }

      let flowSheet = new FlowSheet(vFomrStore['graph_data']);
      let get_flow_path = flowSheet.chooseAllSequence(conditionArr)
      if (typeof get_flow_path == 'object') {
        flow_path = get_flow_path[0];
      }
      data.task_id = that.task_id

      let node_val = {}
      flow_path.map(ret => {
        node_val[ret] = that.$parent.$refs.vFormRef.formDataModel[ret]
      })

      data.flow_line = flow_path.join(',');//线路
      data.node_val = JSON.stringify(node_val);//节点对象

      Http.post("flow/FlowHandle/updateFlowUser", data, ret=>{
        this.buttonLoading = false
        if(ret.code===1){

        }else{
          that.$message.error(ret.msg);
        }
      })
    },
    // 判断是否退回重填
    checkIsReturn(){
      let that = this
      Http.get("flow/FlowForm/checkInstFormIsReturn",{
        task_id:that.task_id
      },res=>{
        if(res.code) {
          that.is_disabled = false
        }
      })
    },
    // 数据验证
    checkFormData(formData) {
      let returnData = {
        'res' : true,
        'msg' : ''
      }
      // 费用报销组件
      if (typeof formData['bao4_xiao1_xiang4_mu4_lie4_biao3'] !== 'undefined') {
        if (formData['bao4_xiao1_xiang4_mu4_lie4_biao3'].length <= 0) {
          // 报销明细为空
          returnData['res'] = false;
          returnData['msg'] = '费用报销项目不能为空！';
        } else {
          // 判断明细里面的金额是否为空
          for (let i=0; i<formData['bao4_xiao1_xiang4_mu4_lie4_biao3'].length; i++) {
            let item = formData['bao4_xiao1_xiang4_mu4_lie4_biao3'][i];
            if (item['allow_reimburse'] == '') {
              returnData['res'] = false;
              returnData['msg'] = item['account_name'] + '费用报销项目金额不能为空！';
            }
          }
        }
        return returnData
      }

      // 月度资金计划
      if (typeof formData['xiang4_mu4_shen1_qing3_lie4_biao3'] !== 'undefined') {
        let formDataXMSQLB = JSON.parse(formData['xiang4_mu4_shen1_qing3_lie4_biao3']);
        if (formDataXMSQLB.length <= 0) {
          // 报销明细为空
          returnData['res'] = false;
          returnData['msg'] = '申请项目不能为空！';
        } else {
          let check = false
          // 判断明细里面的金额是否为空
          for (let i=0; i<formDataXMSQLB.length; i++) {
            let item = formDataXMSQLB[i];
            if (item['ApplyMoney'] !== '') {
              check = true
            }
          }
          if (check) {
            return returnData
          } else {
            return {
              'res' : false,
              'msg' : '请填写实际申请金额！'
            }
          }
        }
      }

      // 预算调整
      if (typeof formData['tiao2_zheng3_xiang4_mu4'] !== 'undefined') {
        // let formDataCheck = JSON.parse(formData['tiao2_zheng3_xiang4_mu4']);
        let formDataCheck = formData['tiao2_zheng3_xiang4_mu4'];
        if (formDataCheck.length <= 0) {
          returnData['res'] = false;
          returnData['msg'] = '请选择项目预算！';
          return returnData
        }
        for (let i=0; i<formDataCheck.length; i++) {
          let item = formDataCheck[i];
          if (item['adjustment_amount'] == '' || item['adjustment_amount'] == 0) {
            returnData['res'] = false;
            returnData['msg'] = item['account_name'] + '的调整增减额不能为空或者为0！';
          }
        }
      }

      return returnData
    },
    // 快捷回复窗口
    quickReplyBox() {
      let that = this
      // 获取快捷回复数据
      this.quickReplyBoxVisible = true
      this.getQuickReply()
    },
    getQuickReply() {
      let that = this
      Http.get("flow/user/quickReplyList",{},res=>{
        if(res.code) {
          that.msgTableData = res.data
        }
      })
    },
    // 选择快捷回复
    selectMsg(item) {
      this.quickReplyBoxVisible = false
      this.form.comments = item.content
      this.comments_value = item.content
    },
    addMsgBox(item) {
      this.quickReplyBoxEditVisible = true
      if (item === '') {
        // 新增
        this.msgId = 0
        this.msgText = ""
      } else {
        // 修改
        this.msgId = item.qid
        this.msgText = item.content
      }
    },
    saveMsg() {
      let that = this
      Http.post("flow/user/saveQuickReply",{
        'msgId' : that.msgId,
        'msgText' : that.msgText,
      },res=>{
        if(res.code) {
          that.$message.success(res.msg);
          that.quickReplyBox()
        } else {
          that.$message.error(res.msg);
        }
        this.quickReplyBoxEditVisible = false
      })
    },
    delMsg(item) {
      let that = this
      Http.post("flow/user/delQuickReply",{
        'msgId' : item.qid,
      },res=>{
        if(res.code) {
          that.$message.success(res.msg);
          that.quickReplyBox()
        } else {
          that.$message.error(res.msg);
        }
        this.quickReplyBoxEditVisible = false
      })
    }
  },
  watch:{
    node_id(n){
      this.getNodeData();
    },
    sheet_id(n){
      this.getNodeData();
      this.getNodeStep();
    },
    "form.additional_value":function (n) {
      // if(n){
      //   if(n==='内部会签'){
      //     this.form.comments="内部会签";
      //   }else if(n==='委托处理'){
      //     this.form.comments="委托处理";
      //   }
      // }
      if (n==='内部会签' && (this.form.comments ==='内部会签' || this.form.comments ==='委托处理' || this.form.comments == '拒绝原文意见' || this.form.comments == '重填审批单' || this.form.comments == '同意原文意见' || this.form.comments == '')) {
        this.form.comments = '内部会签'
      }
      if (n==='委托处理' && (this.form.comments ==='委托处理' || this.form.comments ==='内部会签' || this.form.comments == '拒绝原文意见' || this.form.comments == '重填审批单' || this.form.comments == '同意原文意见' || this.form.comments == '')) {
        this.form.comments = '委托处理'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.handle{
  .handle-body{
    //width: 300px;
    margin: 0 auto;

    .handle-item{
      margin-top: 10px;
      margin-bottom: 10px;
      text-align: center;

      .handle-item-file-bottom{
        margin: 5px 0;
        text-align: center;
      }
      .file-list{
        //>>>.el-descriptions--small.is-bordered .el-descriptions-item__cell{
        //  padding: 0 0 8px 0;
        //}
        //>>>.el-descriptions-item__label.is-bordered-label {
        //  padding: 8px 10px;
        //}
      }
    }
  }
}
.history_user_body_item{
  color: #6f7175;
  width: 100%;
  cursor: pointer;
  padding: 2px 0 2px 5px;
  margin: 2px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:hover{
    background-color: #e8e8e8;
  }
  &:active{
    background-color: #b2c7d0;
  }
  &.active{
    background-color: #b2c7d0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/FlowHandleDom.vue